<template>
  <div class="Monitoring">
    <div id="container">
      <app-header :now=3></app-header>
      <div class="left_menu">
        <div class="logo">
          <img src="/static/img/logo.png"/>
          <span>智达云服务平台</span>
        </div>
        <ul>
          <router-link v-for="(item,index) in left" :to="item.route!=null?{name:item.route}:''" :key="index"
                       @click.native="addClassFun(index)" :class='[{active:index==qwerqwre},"aa"]' tag="li"
                       event="click">
            <img :src=[item.icon] style="width: 20px;height: 20px;">
            <span>{{item.name}}</span>
            <div v-if="item.children != null"><img src="/static/img/menu_maker.png" alt=""></div>
            <ul v-if="item.children != null">
              <router-link v-for="(item2,index) in item.children" :to="{name:item2.route}" :class="['bb']" tag="li" :key="index"
                           event="click">{{item2.name}}
              </router-link>
            </ul>
          </router-link>
        </ul>
      </div>
      <!--      <div class="container_nav">-->
      <!--        <span>首页<a></a></span>-->
      <!--        <span class="container_nav_now">今日统计<a></a></span>-->
      <!--      </div>-->
      <div class="container_box">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  // import HelloWorld from './components/HelloWorld'
  import Header from "./Header";

  export default {
    name: 'monitoring',
    components: {
      "app-header": Header,
    },
    data() {
      return {
        qwerqwre: 0,
        left: [
          {
            icon: '/static/img/Operation.svg',
            name: '运营管理',
            show: false,
            route: 'Operation'
          }, /*{
            icon: '/static/img/Equipment.svg',
            name: '设备管理',
            show: false,
            route: 'Equipment'
          },*/ {
            icon: '/static/img/Breakdowns.svg',
            name: '故障管理',
            show: false,
            route: 'Breakdown'
          }, {
            icon: '/static/img/News.svg',
            name: '消息中心',
            show: false,
            route: 'News'
          },
        ]
      }
    },
    created: function () {
      $(function () {
        let aa = $(".aa"),
          bb = $(".bb");
        aa.css('display', 'block');
        aa.find('ul').hide();
        aa.click(function () {
          $(this).find('ul').slideDown(500);
          $(this).siblings().children("ul").slideUp(500);
        });
        bb.click(function () {
          bb.removeClass('now');
          $(this).addClass('now');
        })
      })
    },
    methods: {
      addClassFun: function (index) {
        this.qwerqwre = index;
      }
    }
  }
</script>

<style scoped>
  .left_menu {
    width: 270px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: -webkit-linear-gradient(left, #1f55a9, #006d9f); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, #1f55a9, #006d9f); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #1f55a9, #006d9f); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #1f55a9, #006d9f); /* 标准的语法 */
  }

  .left_menu .logo {
    width: 100%;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .left_menu .logo img {
    margin-right: 10px;
  }

  .left_menu .logo span {
    font-size: 22px;
    color: #ffffff;
    font-weight: bold;
  }

  .left_menu ul {
    width: 100%;
    height: calc(100% - 78px);
    overflow-y: auto;
  }

  .left_menu > ul > li {
    line-height: 55px !important;
    min-height: 55px;
    position: relative;
    cursor: pointer;
  }

  .left_menu > ul > li img:nth-child(1) {
    margin-left: 37px;
    margin-right: 25px;
    font-size: 20px;
    color: #ffffff;
    display: inline-block;
  }

  .left_menu > ul > li span:nth-child(2) {
    color: #ffffff;
  }

  .left_menu > ul > li div {
    position: absolute;
    right: 37px;
    top: 0;
  }

  .left_menu > ul > li > ul {
    width: 100%;
  }

  .left_menu > ul > li > ul > li {
    height: 50px;
    margin-left: 85px;
    color: #ffffff;
    cursor: pointer;
  }

  .left_menu > ul > .active {
    height: auto;
    background: rgba(15, 49, 79, 0.5);
    position: relative;
  }

  .left_menu > ul > .active:before {
    width: 3px;
    height: 55px;
    left: 0;
    top: 0;
    content: '';
    z-index: 10;
    background: #4a62be;
    display: block;
    position: absolute;
  }

  .left_menu > ul > .active ul {
    background: -webkit-linear-gradient(left, #1f55a9, #006d9f); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, #1f55a9, #006d9f); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #1f55a9, #006d9f); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #1f55a9, #006d9f); /* 标准的语法 */
  }

  .left_menu > ul > .active ul .now {
    color: #00f0ff;
  }

  .container_nav {
    padding-left: 270px;
    width: 100%;
    height: 30px;
    background: #1a5c9c;
    box-sizing: border-box;
  }

  .container_nav > span {
    width: 80px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #FFFFFF;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    cursor: pointer;
  }

  .container_nav > span > a {
    width: 8px;
    height: 8px;
    background: url("/static/img/nav_close.png") no-repeat center center;
    margin-left: 4px;
  }

  .container_nav > .container_nav_now {
    background: #2677c6;
  }

  .container_box {
    padding-left: 270px;
    background: url("/static/img/bg.jpg") no-repeat center center;
    background-size: 100% 100%;
    width: 100%;
    height: calc(100% - 78px);
    overflow-y: auto;
    box-sizing: border-box;
  }

  .information_box {
    position: relative;
    margin-top: 20px;
    float: left;
    background: #0b2f54;
  }

  .gridding {
    background: url("/static/img/gridding.png") #0b2f54 repeat;
  }

  .light_border {
    box-shadow: 0 0 10px #3494f6 inset;
    border: 1px solid #4b9ffc;
  }

  .border_top_left, .border_top_right, .border_bottom_left, .border_bottom_right {
    width: 26px;
    height: 26px;
    position: absolute;
    background: url("/static/img/border.png") no-repeat center center;
  }

  .border_top_left {
    left: -2px;
    top: -2px;
  }

  .border_top_right {
    right: -2px;
    top: -2px;
    transform: rotate(90deg);
  }

  .border_bottom_left {
    left: -2px;
    bottom: -2px;
    transform: rotate(-90deg);
  }

  .border_bottom_right {
    right: -2px;
    bottom: -2px;
    transform: rotate(180deg);
  }

  .h_light_right {
    width: 4px;
    height: 180px;
    background: url("/static/img/H_light-right.png") no-repeat center center;
    position: absolute;
    right: -2px;
  }

  .information_title {
    position: absolute;
    z-index: 2;
    width: 236px;
    height: 35px;
    background: url("/static/img/i_title.png") no-repeat center center;
    top: -18px;
    left: 50%;
    margin-left: -118px;
  }

  .information_title_sm {
    position: absolute;
    z-index: 2;
    width: 142px;
    height: 35px;
    background: url("/static/img/l_title.png") no-repeat center center;
    top: -18px;
    left: 50%;
    margin-left: -71px;
  }

  .information_title > p, .information_title_sm > p {
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    font-size: 20px;
    color: #fbff67;
  }

  .information_title > div, .information_title_sm > div {
    width: 180px;
    height: 6px;
    position: absolute;
    left: 57px;
    bottom: -3px;
    background: url("/static/img/H_light.png") no-repeat center center;
  }

  .information_title_sm > div {
    left: -10px !important;
  }

  .information_content {
    width: 100%;
    height: 100%;
  }

  .table_warning {
    background: #ec354f;
  }

  .table_normal {
    background: #00fafe;
  }

  .anchorBL {
    display: none;
  }
  input[type='checkbox'] {
    width: 20px;
    height: 20px;
    -webkit-appearance: none;
    border-radius: 2px;
    background: url(/static/img/nocheckbox.png) no-repeat center;
    background-size: 100% 100%;
    outline: none;
  }

  input[type=checkbox]:checked {
    background: url(/static/img/checkbox.png) no-repeat center center;
    background-size: 100% 100%;
  }
  ::-webkit-scrollbar-track-piece {
    background-color: transparent; /*滚动条的背景颜色*/
    -webkit-border-radius: 0; /*滚动条的圆角宽度*/
  }

  ::-webkit-scrollbar {
    width: 8px; /*滚动条的宽度*/
    height: 8px; /*滚动条的高度*/
  }

  ::-webkit-scrollbar-thumb { /*垂直滚动条的样式*/
    height: 50px;
    background-color: #95bee5;
    -webkit-border-radius: 4px;
    outline-offset: -2px;
  }

  ::-webkit-scrollbar-thumb:hover { /*滚动条的hover样式*/
    height: 50px;
    background-color: #00f0ff;
    -webkit-border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Management.vue